const filterContacts = (contacts, squashSameBroker = false) => {
  const map = {};

  return contacts
    .map((contact, i) => {
      const imageUrl = (contact.image || {}).url;
      if (!imageUrl) return null;

      if (squashSameBroker && map[imageUrl]) return null;
      map[imageUrl] = true;

      const imageAlt = ((contact.image || {}).data || {}).alt;

      return {
        brokerId: contact.brokerId,
        brokerName: contact.brokerName,
        name: contact.name,
        phone: contact.phone,
        website: contact.website,
        image: {
          url: imageUrl,
          alt: imageAlt
        }
      };
    })
    .filter(filteredContact => !!filteredContact);
};

export default filterContacts;
